// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2XJrF","topBottomGutter":"Layout_topBottomGutter__3mM_S"};